<template lang="pug">
  v-flex#confirmation-loans(xs12 sm12 md12 lg12)
    // - ALREADY IN STEP-3
    v-layout(row wrap)
      v-flex(xs12 sm12 md3 lg3)
      v-flex.header-loans(xs12 sm12 md6 lg6)
        h1.mb-4(v-if="$vuetify.breakpoint.mdAndUp") Validación
      v-flex(xs12 sm12 md3 lg3)
    v-layout.mt-1(wrap row justify-center)
      v-flex.form-confirmation(xs12 sm9 md5 lg4)
        img.mb-2(:src="icons.main" alt="confirmation-main")
        h2.omnesMedium Necesitamos validar que eres tú
        h3.mt-3.info--text Te hemos enviado una clave SMS al celular
        p.omnesMedium.info--text {{ celphone }}
        v-layout(wrap row justify-center)
          v-flex(xs9 sm8 md8 lg8)
            v-layout(row wrap justify-center)
              v-flex(xs2)
                v-text-field.enter-code(v-model="code" type="tel" ref="code" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 1)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code2" type="tel" ref="code2" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 2)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code3" type="tel" ref="code3" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 3)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code4" type="tel" ref="code4" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 4)")
              v-flex(xs2)
                v-text-field.enter-code(v-model="code5" type="tel" ref="code5" maxlength="1" placeholder=" " @keyup.native="validateCode($event, 5)" @keyup.enter="showDialogConfirmation")
          v-flex(xs12 sm10 lg10 xl8)
            span.lh-1.info--text(style="margin-top: 13px;") Al hacer clic en confirmar, acepto que se realice la transacción junto con los términos y condiciones de la misma.
    v-layout(wrap row justify-center)
      v-flex.text-xs-center(xs11 md6)
        br
        v-btn#btn-confirmation(color="primary" :disabled="!code || !code2 || !code3 || !code4 || !code5 || dialogConfirmationLoan || loader" @click="showDialogConfirmation") Confirmar
        //- br
        //- router-link.mt-4(to="../../prestamos/no-recibi-codigo" style="font-size:16px;") No he recibido el mensaje de texto
        //- router-link.mt-2(to="../../prestamos/no-recuerdo-datos" style="font-size:16px;") No cuento con este númeto de teléfono
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Procesando el préstamo...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- MODAL DE ERROR - GENERICO PARA MENSAJES
    v-dialog(v-model="dialogConfirmationLoan", persistent, width="500")
      v-card#confirmation-loan-modal
        v-btn.youtube-close-btn(icon, @click="dialogConfirmationLoan = false", outlined, style="border: rgb(8, 85, 196)") x
        figure.text-xs-center
          img(:src="icons.info" alt="iconError")
        h2.text-blue.text-xs-center ¡Atención!
        p.mt-3.text-xs-center
          span.d-block.g-text-gray-700(style="font-size:16px")
            | Estás a un paso de aceptar tu préstamo.
            br
            | Si quieres continuar dale clic en Aceptar.
        v-layout(wrap row)
          v-flex.text-xs-center(xs12 md12 lg12)
            button.transition-all-3.hover-scale.accept.omnesMedium(style="font-size:16px" :disabled="loader" @click="confirmTransact()") Aceptar
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Functionalities from '../../interfaces/functionalities'
import trackingMixin from '../../mixins/trackingMixin'
// import moment from 'moment'

export default {
  mixins: [trackingMixin],
  props: ['cronograma', 'data', 'uniqueTrackId'],
  data () {
    return {
      celphone: null,
      dialogConfirmationLoan: false,
      loader: false,
      code: null,
      code2: null,
      code3: null,
      code4: null,
      code5: null,
      icons: {
        main: require('./../../assets/iconsv4/crear_cuenta_icon.svg'),
        info: require('./../../assets/general/personaje_computador_2.svg')
      },
      amplitude: {
        events: {
          loanSuccessful: 'Préstamo realizado'
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'polizasInfo', 'basicInfo', 'functionsRules'])
  },
  watch: {
    dialogConfirmationLoan (isVisible) {
      if (!isVisible) return

      this.trackValidationPopup('Estas a un paso de aceptar tu prestamo. Si quieres continuar dale click en aceptar.')
    }
  },
  methods: {
    ...mapActions('user', ['validateCodigoPrestamo', 'setEstadoPrestamo', 'sendCronogramaPago', 'getInformacionPrestamo', 'saveCronogramaPrestamo', 'setTrackingClient']),
    validateCode (evt, pos) {
      let charCode = (evt.which) ? evt.which : evt.keyCode
      switch (pos) {
      case 1:
        if (this.code !== null && this.code !== '') { this.$refs.code2.focus() }
        break
      case 2:
        if (charCode === 8) {
          this.$refs.code.focus()
        } else if (this.code2 !== null && this.code2 !== '') {
          this.$refs.code3.focus()
        }
        break
      case 3:
        if (charCode === 8) {
          this.$refs.code2.focus()
        } else if (this.code3 !== null && this.code3 !== '') {
          this.$refs.code4.focus()
        }
        break
      case 4:
        if (charCode === 8) {
          this.$refs.code3.focus()
        } else if (this.code4 !== null && this.code4 !== '') {
          this.$refs.code5.focus()
        }
        break
      case 5:
        if (charCode === 8) {
          this.$refs.code4.focus()
        }
        break
      }
    },
    showDialogConfirmation () {
      this.dialogConfirmationLoan = true

      this.$gtm.trackEvent({
        "event":"select_button",
        "Nombre Sección":"Zona Segura",
        "TipoElemento":"Botón",
        "TipoAccion":"Préstamo - paso 3 - confirmar",
        "CTA":"Confirmar"
      })
    },
    confirmTransact () {
      const self = this
      this.dialogConfirmationLoan = false
      this.loader = true
      let codigo = this.code + this.code2 + this.code3 + this.code4 + this.code5
      this.validateCodigoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, codigo: codigo })
        .then((resValidate) => {
          const callbackNPS = (err) => {
            setTimeout(() => {
              self.$root.$emit('showNps', {
                nombre: 'NPS - Inicio de Encuesta',
                funcionalidad: 'Descarga de Comprobante',
                metadata: {
                  error: err,
                  numeroPoliza: localStorage.getItem('selPol'),
                  productoConsultado: 'RRVV',
                  subproductoConsultado: self.data.product
                }
              })
            }, 3000)
          }
          if (resValidate.data.codigoRespuesta === '01') {
            this.getInformacionPrestamo({poliza: localStorage.getItem('selPol'), vista: 'LoansThirdStep'})
              .then((resInfo) => {
                let numeroPoliza = resInfo.data.numeroPoliza
                let codigoMoneda = resInfo.data.moneda.codigo
                let codigoPrestamo = (Math.floor(Math.random() * 900000) + 100000) + ''
                // EVENT TRACK
                this.$gtm.trackEvent({
                  event: 'Préstamo Exitoso',
                  id_prestamo: codigoPrestamo
                })
                // DATA GENERAL
                let today = new Date()
                let currentDate = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2)
                let currentDateDesembolso = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + '01'
                let amount = parseFloat(this.data.amount.replace('S/', '').replace('$', '').replace('S', '').replace('/', '').replace(',', ''))
                // CREACION CRONOGRAMA
                let cronograma = this.cronograma
                // ENVIO CRONOGRAMA
                let cronogramaADMWR = {
                  NumeroPoliza: numeroPoliza,
                  CodPrestamo: codigoPrestamo,
                  MonedaPrestamo: codigoMoneda,
                  MontoPrestamo: amount,
                  FechaAprobacion: currentDate,
                  tea: parseFloat(this.data.percent),
                  PeriodoDesembolso: currentDateDesembolso,
                  Cronograma: null
                }
                let arrayCronograma = []
                for (let index = 0; index < cronograma.length; index++) {
                  let hash = {
                    Periodo: this.data.startLoan.clone().add(cronograma[index].periodoPrestamo - 1, 'months').format('YYYY-MM-01'),
                    Total: parseFloat(cronograma[index].cuota),
                    Descuento: [
                      {
                        Codigo: '111',
                        Monto: cronograma[index].principal
                      },
                      {
                        Codigo: '112',
                        Monto: cronograma[index].intIS
                      },
                      {
                        Codigo: '113',
                        Monto: cronograma[index].IGV
                      }
                    ]
                  }
                  arrayCronograma.push(hash)
                }
                cronogramaADMWR.Cronograma = arrayCronograma
                this.saveCronogramaPrestamo(cronogramaADMWR)
                  .then(resadmwr => {
                    if (resadmwr.data.codigoRespuesta === '01') {
                      this.cronograma[0].codigoUsuario = this.userInfo.codigoUsuario
                      this.cronograma[0].nombreCliente = this.data.client
                      this.cronograma[0].producto = this.data.product
                      this.cronograma[0].numeroPoliza = numeroPoliza
                      this.cronograma[0].numeroDocumento = this.data.numberPolicy
                      this.cronograma[0].montoPrestamo = this.data.amount
                      this.cronograma[0].numeroNumCuotas = this.data.numberQuota
                      this.cronograma[0].montoCuota = this.data.amountQuota
                      this.cronograma[0].codigoPrestamo = codigoPrestamo
                      this.cronograma[0].tasa = this.data.percent
                      this.cronograma[0].devolucion = this.data.refund
                      this.cronograma[0].inicioPago = this.data.startPay.locale('es').format('MMMM YYYY').charAt(0).toUpperCase() + this.data.startPay.locale('es').format('MMMM YYYY').slice(1)
                      this.cronograma[0].finPago = this.data.endPay
                      this.sendCronogramaPago(this.cronograma)
                        .then(res => {
                          this.setEstadoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, flag: false })
                            .then(res => {
                              this.loader = false
                              // TRACK EVENT - AMPLITUDE
                              this.$amplitude.getInstance()
                                .logEvent(
                                  this.amplitude.events.loanSuccessful,
                                  {
                                    'Monto cotizado': amount,
                                    'Cuotas': this.data.numberQuota,
                                    'Moneda': codigoMoneda === '001' ? 'S/' : '$',
                                    'Opción': this.data.option
                                  }
                                )
                              // [SEND TRACKING]
                              let hashT = [{
                                categoria: 'Prestamos RPP-IFP',
                                trackingId: this.uniqueTrackId,
                                screen: 'finalizado',
                                document: this.basicInfo.numeroDocumento,
                                name: this.basicInfo.nombres,
                                email: this.basicInfo.correo,
                                phone: this.basicInfo.celular,
                                data: '',
                                errorType: '',
                                errorData: '',
                                date: Date.now()
                              }]
                              this.setTrackingClient(hashT)
                              // [SEND TRACKING]
                              this.$router.push({
                                name: 'LoansFinished',
                                params: {amount: this.data.amount, bank: this.data.bank, numberAccount: this.data.numberAccount}
                              }).then(() => callbackNPS()).catch(() => callbackNPS())
                            })
                        })
                        .catch((err) => {
                          this.loader = false
                          this.$swal({
                            title: 'Atención',
                            text: 'Tenemos un inconviente. Por favor, vuelve a intentarlo en unos minutos.',
                            type: 'error',
                            confirmButtonText: 'Entendido'
                          }).then((result) => {
                            this.setEstadoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, flag: false })
                              .then(res => {
                                self.$router.push({ name: 'Home' })
                                callbackNPS(err)
                              })
                          })
                        })
                    } else {
                      this.loader = false
                      
                      // Se definen mensajes según el código de respuesta
                      let mensajeError
                      
                      switch(resadmwr.data.codigoRespuesta) {
                        case '97':
                          mensajeError = 'Ya tienes un préstamo registrado hoy. Puedes intentarlo nuevamente mañana.'
                          break
                        case '98':
                          mensajeError = 'No se pudo procesar tu solicitud.'
                          break
                        default:
                          mensajeError = 'Tenemos un inconveniente. Por favor, vuelve a intentarlo en unos minutos.'
                          break
                      }
                      
                      this.$swal({
                        title: 'Atención',
                        text: mensajeError,
                        type: 'error',
                        confirmButtonText: 'Entendido'
                      }).then((result) => {
                        this.setEstadoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, flag: false })
                          .then(res => {
                            this.$router.push({ name: 'Home' }).then().then(() => callbackNPS({...resadmwr.data})).catch(() => callbackNPS({...resadmwr.data}))
                          })
                      })
                    }
                  })
                  .catch((err) => {
                    this.loader = false
                    this.$swal({
                      title: 'Atención',
                      text: 'Tenemos un inconviente. Por favor, vuelve a intentarlo en unos minutos.',
                      type: 'error',
                      confirmButtonText: 'Entendido'
                    }).then((result) => {
                      this.setEstadoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, flag: false })
                        .then(res => {
                          this.$router.push({ name: 'Home' }).then(() => callbackNPS(err)).catch(() => callbackNPS(err))
                        })
                    })
                  })
              })
              .catch((err) => {
                this.loader = false
                this.$swal({
                  title: 'Atención',
                  text: 'Tenemos un inconviente. Por favor, vuelve a intentarlo en unos minutos.',
                  type: 'error',
                  confirmButtonText: 'Entendido'
                }).then((result) => {
                  this.setEstadoPrestamo({ codigoUsuario: this.userInfo.codigoUsuario, flag: false })
                    .then(res => {
                      this.$router.push({ name: 'Home' }).then(() => callbackNPS(err)).catch(() => callbackNPS(err))
                    })
                })
              })
          }
        })
        .catch(() => {
          this.loader = false

          this.trackValidationPopup('El codigo que has ingresado no es el correcto. Vuelve a intentarlo')
          this.$swal({
            title: 'Advertencia',
            text: 'El código que has ingresado no es el correcto. Vuelve a intentarlo.',
            type: 'error',
            confirmButtonText: 'Entendido'
          })
        })
    }
  },
  mounted () {
    const self = this
    if (!Functionalities.isAvailableSilent(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
      self.$router.push('/inicio')
      return
    }
    this.celphone = this.polizasInfo.filter(f => { return f.numeroPoliza === localStorage.getItem('selPol') })[0].celular
    
    this.$gtm.trackEvent({
      "event":"content-view",
      "content-name":"/zona-segura/prestamos/paso/validar",
      "content-view-name":"Préstamo cotizador - paso 3"
    })
  }
}
</script>

<style>
#confirmation-loans .header-loans h1 {
  text-align: center;
  margin-bottom: 1.3em;
  font-weight: normal;
}
#confirmation-loans .form-confirmation { text-align: center; }
#confirmation-loans .form-confirmation img { width: 7rem; }
#confirmation-loans .form-confirmation p:first-of-type {
  font-family: 'Omnes Medium';
  font-size: 19px;
  margin-bottom: 5px;
  /* margin-top: 1.2em; */
}
#confirmation-loans .form-confirmation .enter-code .v-input__control .v-text-field__details { display: none; }
#confirmation-loans .form-confirmation .enter-code  { width: 65%; margin: 0 auto; display: block; }
#confirmation-loans .form-confirmation span:first-of-type {
  width: 90%;
  margin: 0 auto;
  display: block;
}
#confirmation-loans .form-confirmation span:first-of-type {
  font-size: 12px;
}
#confirmation-loans .form-confirmation .enter-code .v-input__control .v-input__slot .v-text-field__slot input {
  text-align: center;
  font-size: 25px;
  color: #0855C4;
  /* letter-spacing: 12px; */
}
#confirmation-loans .form-confirmation p:first-of-type + p { margin-bottom: 2px; }
#confirmation-loans .form-confirmation p:first-of-type + p + p { font-family: 'Omnes Medium'; }
#confirmation-loans button#btn-confirmation:not(.v-btn--disabled) {
  background-color: rgb(234,12,144) !important;
  border-color: rgb(234,12,144) !important;
}
#confirmation-loans a { display: block; }
#confirmation-loans a:first-of-type { margin-top: 1.5em; }
#confirmation-loans a:first-of-type + a { margin-bottom: 1em; }
#confirmation-loan-modal {
  padding: 1.4em 2em;
}
#confirmation-loan-modal p {
  margin: 25px 0 !important;
}
#confirmation-loan-modal figure img { width: 32%; }
#confirmation-loan-modal .layout .flex button.accept {
  background-color: rgb(234,12,144) !important;
  border-color: rgb(234,12,144) !important;
}
#confirmation-loan-modal .layout .flex button {
  width: 70%;
  height: 50px;
  color: #FFF;
  border-radius: 9px;
}
/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  #confirmation-loans .form-confirmation p:first-of-type { font-size: 18px; }
  #confirmation-loans .form-confirmation span:first-of-type {
    width: 98%;
    margin: 0 auto;
    font-size: 13px;
  }
}
#confirmation-loan-modal span.d-block.g-text-gray-700 {
  color: #454A6C;
}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/LoansThridStep.vue